import { Grid, html } from "gridjs";
import { deDE } from "gridjs/l10n/dist/l10n";
import dataActiveAgent from "../dataActiveAgent.json"
import dataXandrInvest from "../dataXandrInvest.json"
import dataTTD from "../dataTTD.json"
import dataDV360 from "../dataDV360.json"
import swal from 'sweetalert';

let currentButton = '';
let grid = null;
let leftButtonActive = false;
let rightButtonActive = false;

// ---- Hilfsfunktionen ----

function slugify(text) {
    return text
        .toString()
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '-')           // Leerzeichen → Bindestriche
        .replace(/[^\w\-]+/g, '')       // Sonderzeichen entfernen
        .replace(/\-\-+/g, '-');        // Mehrfache Bindestriche zusammenfassen
}

function getQueryParam(name) {
    return new URLSearchParams(window.location.search).get(name);
}

function getSegmentBySlug(data, slug) {
    for (let row of data) {
        const targeting = row[0]; // z.B. "ablida television"
        if (slugify(targeting) === slug) {
            return row[0]; // Hier: Original-Name zurückgeben, nicht ID
        }
    }
    return null;
}

// ---- Modal Handler ----

window.openModal = function (cell, segment) {
    document.querySelector('#segment').innerText = segment;

    MicroModal.show('bookingModal', {
        onClose: function (modal) {
            const form = modal.querySelector('form');
            if (form) form.reset();
            $('#form-notice').text('');
            const sendButton = modal.querySelector('input[type="submit"]');
            if (sendButton) sendButton.removeAttribute('disabled');
        },
    });
};

// ---- Haupttabelle ----

const netzeColumn = {
    name: 'Netze',
    formatter: (cell, row) => {
        const weeklyNets = window.weeklyNets || [];
        const targetingRaw = row.cells?.[0]?.data || "";
        const targetingKey = targetingRaw.split(' ').slice(1).join(' ').toLowerCase();

        const matchingNets = weeklyNets.filter(net => net.title.toLowerCase() === targetingKey);
        if (matchingNets.length === 0) return html(``);

        return html(`
      <div style="
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        padding: 0;
        overflow: hidden;
      ">
        ${matchingNets.map(net => `
          <a href="${net.url}" target="_blank" rel="noopener noreferrer" style="display: inline-block;">
            <img src="${net.image_url}"
                 style="width: auto; height: 90px; max-width: 300px; display: block;" />
          </a>
        `).join('')}
      </div>
    `);
    }
};

const drawTableWith = (data, highlightSlug = '', expandDescriptions = false) => {
    const wrapper = document.getElementById('tableWrapper');
    if (grid) grid.destroy();

    const columnConfig = currentButton === 'right'
        ? {
            name: 'Jetzt buchen',
            formatter: (cell, row) => html(`
        <button data-segment-id="${cell}" data-micromodal-trigger="bookingModal" onClick="openModal('${cell}', '${row.cells[0].data}')">
          Jetzt buchen
        </button>
      `),
        }
        : {
            name: 'Segment-ID',
            formatter: (cell, row) => html(`
        <button data-segment-id="${row.cells[1].data}" onClick="navigator.clipboard.writeText('${row.cells[1].data}').then(() => { alert('Die Segment-ID wurde in die Zwischenablage kopiert!'); })">
          Kopieren
        </button>
    `),
        };

    grid = new Grid({
        columns: [
            { name: 'Targeting' },
            netzeColumn,
            columnConfig,
            {
                name: 'Beschreibung',
                formatter: (_, row) => {
                    const fullText = row.cells[2].data || '';
                    const targeting = row.cells[0].data || '';
                    const isHighlighted = slugify(targeting) === highlightSlug;

                    const previewLength = 150;
                    const words = fullText.split(' ');
                    let preview = '';
                    for (let word of words) {
                        if ((preview + ' ' + word).length > previewLength) break;
                        preview += (preview ? ' ' : '') + word;
                    }

                    const id = `desc-${Math.random().toString(36).substr(2, 9)}`;
                    const expand = expandDescriptions && isHighlighted;

                    return html(`
            <div>
              <div id="${id}-preview" style="display: ${expand ? 'none' : 'block'};">
                ${preview}...
                <a href="#" onclick="document.getElementById('${id}-preview').style.display='none'; document.getElementById('${id}-full').style.display='block'; return false;">
                  Mehr anzeigen
                </a>
              </div>
              <div id="${id}-full" style="display: ${expand ? 'block' : 'none'};">
                ${fullText}
                <br>
                <a href="#" onclick="document.getElementById('${id}-full').style.display='none'; document.getElementById('${id}-preview').style.display='block'; return false;">
                  Weniger anzeigen
                </a>
              </div>
            </div>
          `);
                }
            }
        ],
        data: data,
        search: true,
        sort: true,
        language: deDE,
        width: '75%',
        style: {
            table: { border: 'none' },
            th: {
                'background-color': '#fff',
                color: '#000',
                'border-bottom': 'none',
                'text-align': 'center',
                height: '20px'
            },
            td: {
                'vertical-align': 'top',
                'white-space': 'normal',
                'word-break': 'break-word',
                'max-width': '500px',
            }
        }
    });

    grid.render(wrapper);
};

// ---- Button Auswahl ----

function getSelectedBoxData() {
    const selectedOption = document.querySelector('input[name="options"]:checked');
    let data;

    if (selectedOption) {
        switch (selectedOption.value) {
            case "Active Agent":
                data = dataActiveAgent;
                break;
            case "Microsoft Advertising":
                data = dataXandrInvest;
                break;
            case "DV360":
                data = dataDV360;
                document.querySelector('.dsp-button-right')?.click();
                break;
            case "TTD":
                data = dataTTD;
                break;
            default:
                break;
        }
    } else {
        data = dataXandrInvest;
    }

    return data;
}

// ---- Event Handler für Buttons & Init ----

document.addEventListener("DOMContentLoaded", function () {
    const segmentSlug = getQueryParam('segment'); // z.B. "foo-television"
    const data = getSelectedBoxData();

    if (segmentSlug) {
        currentButton = 'left';
        document.querySelector('.dsp-button-right')?.classList.remove('active');
        document.querySelector('.dsp-button-left')?.classList.add('active');
        const realSegmentName = getSegmentBySlug(data, segmentSlug); // z.B. "ablida television"

        drawTableWith(data, segmentSlug, true);

        if (realSegmentName) {
            const segmentId = data.find(row => row[0] === realSegmentName)?.[0]?.replace(/\s+/g, "_");
            // Verzögert ausführen wegen async rendering von gridjs
            setTimeout(() => {
                const button = document.querySelector(`button[data-segment-id="${segmentId}"]`);

                if (button) {
                    const row = button.closest('tr');
                    if (row) {
                        row.classList.add('highlighted-segment');
                        row.querySelectorAll('td').forEach(td => {
                            td.style.setProperty('background-color', 'rgba(173, 216, 230, 0.4)', 'important');
                        });
                        row.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                }
            }, 200);
        }
    } else {
        drawTableWith(data);
    }

    const radioButtons = document.getElementsByName('options');
    radioButtons.forEach(radio => {
        radio.addEventListener('change', () => {
            const newData = getSelectedBoxData();
            drawTableWith(newData);
        });
    });

    const leftButton = document.querySelector('.dsp-button-left');
    const rightButton = document.querySelector('.dsp-button-right');

    leftButton.addEventListener('click', function () {
        rightButton.classList.remove('active');
        leftButton.classList.add('active');
        rightButtonActive = false;
        leftButtonActive = true;
        currentButton = 'left';
        const data = getSelectedBoxData();
        drawTableWith(data);
    });

    rightButton.addEventListener('click', function () {
        leftButton.classList.remove('active');
        rightButton.classList.add('active');
        leftButtonActive = false;
        rightButtonActive = true;
        currentButton = 'right';
        const data = getSelectedBoxData();
        drawTableWith(data);
    });
});
